import React, { useState, useEffect } from 'react'

const Result = ({ result }) => {
  let futureLifetimeSavingsOverTermLabel = result ? result.futureLifetimeSavingsOverTermLabel : 0;
  let futurePotentialMonthlySavingsLabel = result ? result.futurePotentialMonthlySavingsLabel : 0;
  let futureInterestRateLabel = result ? result.futureInterestRateLabel : 0;
  let futureComparisonRateLabel = result ? result.futureComparisonRateLabel : 0;
  let futurePaymentPerMonthLabel = result ? result.futurePaymentPerMonthLabel : 0;

  const howItWorksFullText = 'The mortgage refinance calculator will show you the reduction in monthly repayment and the amount of interest you will save over the life of the loan. To get started, enter your current loan amount, interest rate & other monthly fees and the remaining loan term.'
  const howItWorksCollapsedText = 'The mortgage refinance calculator will show you the reduction in monthly repayment and the amount of interest you will save...'

  const [expanded, setExpanded] = useState(false);
  const [howItWorksText, setHowItWorksText] = useState(howItWorksCollapsedText);

  const handleReadMore = () => {
    const text = !expanded ? howItWorksFullText : howItWorksCollapsedText
    setExpanded(!expanded)
    setHowItWorksText(text)
  }

  useEffect(() => {
    if (futureLifetimeSavingsOverTermLabel !== 0 ) {
      document.querySelector('.result-container').style.display = 'block'
    }
  }, [futureLifetimeSavingsOverTermLabel])

  return (
    <div className="estimate-refinance-result-container">
      <div className='result-container'>
        <div className="calc-result-container">
          <div className='result-label'>Your savings with a Yard loan</div>
          <h4 className='result-text'><span className='result-number'>{futurePotentialMonthlySavingsLabel}</span> per month</h4>
          <div className='result-label'>Savings over the life of the loan</div>
          <h4 className='result-text'><span className='result-number'>{futureLifetimeSavingsOverTermLabel}</span></h4>
          <hr className='result-horizontal-line'/>

          <div className='result-label'>New repayment</div>
          <h4 className='result-text'><span className='result-number'>{futurePaymentPerMonthLabel}</span>per month</h4>
          <hr />

          <div className='interest-rate-container'>
            <div className='interest-rate'>
              <div className='result-label'>Interest rate</div>
              <h4 className='result-text'><span className='result-number'>{futureInterestRateLabel}</span>p.a.</h4>
            </div>
            <div className='interest-rate'>
              <div className='result-label'>Comparison rate</div>
              <h4 className='result-text'><span className='result-number'>{futureComparisonRateLabel}</span>p.a.</h4>
            </div>
          </div>
        </div>

        <div className='ready-to-refinance-container'>
          <div className='text'>Ready to refinance?</div>
          <div className='buttons-container'>
            <a className="btn btn-lg btn-green mr-sm-2 apply-now-btn" id="apply-now-btn" href='/onboarding_funnel/new'>
              Apply now
            </a>
            <span 
              className="btn btn-lg btn-line-green ml-sm-2 view-rates-btn" 
              onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }
              id="view-rates-btn">
              Talk to an expert
            </span>
          </div>
        </div>
      </div>

      <div className='how-it-works'>
        How does it work
        <p className='mt-2 how-it-works-text'>{howItWorksText}</p>
        {!expanded &&
          <b onClick={handleReadMore}>Read more</b>
        }
      </div>
    </div>
  );
}
export default Result
